var remove_itens = document.querySelectorAll('.icon-minus');

if(remove_itens != null) {
    remove_itens.forEach(element => {
        element.addEventListener('click', btn => {
            setTimeout(() => {
                location.reload();
            }, 200); 
        });
    });
}